import { render, staticRenderFns } from "./ChangePopup.vue?vue&type=template&id=d9b2af6a&scoped=true&"
import script from "./ChangePopup.vue?vue&type=script&lang=js&"
export * from "./ChangePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b2af6a",
  null
  
)

export default component.exports